/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./TeamsList.module.css";

import Link from "next/link";
import { Avatar } from "src/components/avatar/avatar";
import { Icon } from "src/components/icon/icon";
import { formatDateMY } from "src/utils/dates/dates";
import { formatNumber } from "src/utils/intl/number";

import type { TeamType } from "../api/teamItem";
import { useSession } from "src/components/session/session";

interface Props {
  teams: TeamType[];
}

export default function TeamsList(props: Props) {
  const session = useSession();

  return (
    <table className={styles.table}>
      <tbody>
        {props.teams.map((team) => (
          <tr key={team.handle}>
            <td className={styles.avatarColumn}>
              <Link href={`/${team.handle}`}>
                <Avatar
                  src={team.profile_image_url}
                  ownerId={team.id}
                  handle={team.handle}
                  type="team"
                  size={25}
                />
              </Link>
            </td>

            <td>
              <div className={styles.multiline}>
                <div className={styles.nameAndMembers}>
                  <Link href={`/${team.handle}`} className={styles.teamName}>
                    {team.name}
                  </Link>

                  {team.members.length > 0 && (
                    <ul className={styles.teamMembers}>
                      {team.members
                        .sort(placeFirst(session?.user?.name))
                        .slice(0, 10)
                        .reverse()
                        .map((user) => (
                          <li key={user.name}>
                            <Link prefetch={false} href={`/${user.name}`}>
                              <Avatar
                                src={user.profile_image_url}
                                ownerId={user.id}
                                handle={user.name}
                                type="user"
                                size={20}
                              />
                            </Link>
                          </li>
                        ))}
                    </ul>
                  )}
                </div>

                <div className={styles.userName}>
                  Created {formatDateMY(team.created_at)}
                </div>
              </div>
            </td>

            <td>
              <div className={styles.favorites}>
                {formatNumber(team.receivedStars)}
                <Icon icon="star-fill" />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function placeFirst(name: string | undefined) {
  if (!name) {
    // Keep original order
    return () => 0;
  }
  // Place user with provided name first in list
  return (one: { name: string }, two: { name: string }) => {
    if (one.name === name) {
      return -1;
    }
    if (two.name === name) {
      return 1;
    }
    return 0;
  };
}
